import React from 'react';
import { motion } from 'framer-motion';
import {
  SiReact,
  SiTypescript,
  SiNodedotjs,
  SiMongodb,
  SiTailwindcss,
  SiGit,
} from 'react-icons/si';

const skills = [
  { name: 'React.js', level: 90, icon: <SiReact className="text-blue-400 text-2xl" /> },
  { name: 'TypeScript', level: 85, icon: <SiTypescript className="text-blue-500 text-2xl" /> },
  { name: 'Node.js', level: 80, icon: <SiNodedotjs className="text-green-500 text-2xl" /> },
  { name: 'MongoDB', level: 75, icon: <SiMongodb className="text-green-400 text-2xl" /> },
  { name: 'Tailwind CSS', level: 90, icon: <SiTailwindcss className="text-cyan-400 text-2xl" /> },
  { name: 'Git', level: 85, icon: <SiGit className="text-orange-400 text-2xl" /> },
];

const Skills = () => {
  return (
    <section id="skills" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
          Technical Skills
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {skills.map((skill, index) => (
            <motion.div
              key={skill.name}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-gray-700 p-6 rounded-lg shadow-lg"
            >
              <div className="flex justify-between items-center mb-2">
                <div className="flex items-center gap-3">
                  {skill.icon}
                  <span className="text-xl font-semibold">{skill.name}</span>
                </div>
                <span className="text-blue-400">{skill.level}%</span>
              </div>
              <div className="w-full bg-gray-600 rounded-full h-2.5">
                <motion.div
                  className="bg-gradient-to-r from-blue-400 to-purple-400 h-2.5 rounded-full"
                  initial={{ width: 0 }}
                  whileInView={{ width: `${skill.level}%` }}
                  transition={{ duration: 1, delay: index * 0.1 }}
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
